export default "__VITE_ASSET__BshzQ5d7__"